import type { Stage } from '../../../types'
import { cn } from '../../../lib/utils'

// The scroller's top can land on a fractional pixel, leaving a sliver above the
// sticky row where scrolled set blocks bleed through — the upward shadow plugs it.
const SEAL = 'shadow-[0_-2px_0_var(--background)]'

export function DayGridHeaders({ dayStages }: { dayStages: Stage[] }) {
  return (
    <>
      {/* Stage headers + time column — sticky so they remain visible while
          scrolling. z-index stack: now-line (20) < hover-lifted set blocks
          (30) < now-dot (35) < sticky time column / header row (40) < sticky corner (50). */}
      <div style={{ gridRow: 1, gridColumn: 1, position: 'sticky', top: 0, zIndex: 40 }} className={cn('bg-background md:bg-muted md:border-b', SEAL)} />
      <div style={{ gridRow: 1, gridColumn: dayStages.length + 2, position: 'sticky', top: 0, zIndex: 40 }} className={cn('bg-background md:hidden', SEAL)} />
      {/* Backing cells behind the first/last stage headers to plug the rounded-corner gap */}
      <div style={{ gridRow: 1, gridColumn: 2, position: 'sticky', top: 0, zIndex: 39 }} className={cn('bg-background md:hidden', SEAL)} />
      <div style={{ gridRow: 1, gridColumn: dayStages.length + 1, position: 'sticky', top: 0, zIndex: 39 }} className={cn('bg-background md:hidden', SEAL)} />
      {dayStages.map((stage, i) => (
        <div
          key={stage.id}
          style={{ gridRow: 1, gridColumn: i + 2, position: 'sticky', top: 0, zIndex: 40 }}
          className={cn(
            'flex items-center justify-center border-b bg-muted overflow-hidden min-w-0',
            SEAL,
            i === 0 ? 'border-l rounded-tl-md md:rounded-none md:border-l-0' : 'border-l',
            i === dayStages.length - 1 && 'border-r rounded-tr-md md:rounded-tr-none md:border-r-0',
          )}
        >
          <span className="text-xs font-semibold px-1 truncate">{stage.name}</span>
        </div>
      ))}
    </>
  )
}
